
import { getInstance } from '../../../scripts/lib/views.js';
import FormField from '../form-field/form-field';

const name = 'form-list';

export default class FormList {

  constructor ($el) {
    this.$el = $el;
    this.name = $el.dataset.name;
    this.delegate = null;
    this.isHidden = false;

    this.$list = $el.querySelector(`.${name}__list`);
    this.$rows = [...this.$list.querySelectorAll(`.${name}__row`)];

    // The first row is also the template for the next ones
    const $firstRow = this.$rows[0];
    this.$template = $firstRow.cloneNode(true);

    // Init first row
    const $removeButton = $firstRow.querySelector(`.${name}__btn-remove`);
    $removeButton.onclick = this.onRowRemoveClick.bind(this, $firstRow);

    const $addButton = $firstRow.querySelector(`.${name}__btn-add`);
    $addButton.onclick = this.onRowAddClick.bind(this);

    const $field = $firstRow.querySelector('.form-field');
    const field = getInstance($field, FormField);

    // Keep instances to row fields
    this.rowFields = [field];

    if ($el.dataset.conditionField && $el.dataset.conditionValue) {
      this.withCondition = true;
    }
  }

  /**
   * Sets this field's delegate.
   * @param {object} delegate
   * @return this
   */
  setDelegate (delegate) {
    this.delegate = delegate;

    if (this.withCondition) {

      // Do not allow fields to set themselves as conditional fields
      if (this.name !== this.$el.dataset.conditionField) {

        this.delegate.registerConditionalField(
          this,
          this.$el.dataset.conditionField,
          this.$el.dataset.conditionValue
        );
      }
    }

    return this;
  }

  /**
   * Triggered when add button has been clicked.
   * @param {Event} evt Mouse event
   */
  onRowAddClick (evt) {
    evt.preventDefault();

    // Create row from template
    const $row = this.$template.cloneNode(true);

    // Init row
    const $removeButton = $row.querySelector(`.${name}__btn-remove`);
    $removeButton.onclick = this.onRowRemoveClick.bind(this, $row);

    const $addButton = $row.querySelector(`.${name}__btn-add`);
    $addButton.onclick = this.onRowAddClick.bind(this);

    const $field = $row.querySelector('.form-field');
    const field = getInstance($field, FormField);

    // Append row
    this.$rows.push($row);
    this.rowFields.push(field);
    this.$list.appendChild($row);
  }

  /**
   * Triggered when remove button has been clicked.
   * @param {HTMLElement} $row Sender row element
   * @param {Event} evt Mouse event
   */
  onRowRemoveClick ($row, evt) {
    evt.preventDefault();

    const index = this.$rows.indexOf($row);
    if (index !== -1 && this.$rows.length > 1) {
      this.$rows.splice(index, 1);
      this.rowFields.splice(index, 1);
      this.$list.removeChild($row);
    }
  }

  /**
   * Returns field name.
   * This method gets called from the parent form instance.
   * @return {string} Field name
   */
  getName () {
    return this.name;
  }

  /**
   * Returns field value.
   * This method gets called from the parent form instance.
   * @return {string} Field value
   */
  getValue () {
    // Join together text field values with a line break character if not hidden
    return this.isHidden ? '' :
      this.rowFields
      .map(field => field.getValue())
      .filter(value => !!value)
      .join('\n');
  }

  /**
   * Returns wether this field is valid.
   * This method gets called from the parent form instance.
   * @return {boolean}
   */
  isValid () {
    return this.rowFields.reduce((valid, field) =>
      valid && field.isValid(), true);
  }

  /**
   * Validates field.
   * This method gets called from the parent form instance.
   * @return {boolean}
   */
  validate () {
    if (!this.shouldValidate) {
      // Skip validation if field should not be validated
      return this.isValid();
    }

    this.rowFields.forEach(field => field.validate());

    return this.isValid();
  }

  /**
   * Called from the delegate this function takes care of handling
   * state changes if the conditional field changed
   *
   * @param newStatus
   */
  toggleConditional (newStatus) {
    console.log(this.$el);
    if (this.$el.dataset.conditionValue === newStatus) {
      this.$el.classList.remove(`${name}__hidden`);
      this.shouldValidate = true;
      this.isHidden = false;
    } else {
      this.$el.classList.add(`${name}__hidden`);
      this.shouldValidate = false;
      this.isHidden = true;
    }
  }
}
